<template>
	<HighlightTool />
</template>

<script>
import HighlightTool from '@js/one/modules/Highlight/HighlightTool.vue';

export default {
	name:       'Highlight',
	components: { HighlightTool },
	beforeMount() {
		if (window.isAtv) {
			const newRoute = window.location.pathname.replace('/highlight', '');
			window.location.href = newRoute;
		}
	},
};
</script>

<style lang="scss" scoped>
</style>
